<template>
  <v-form @submit.prevent="submit"
          :disabled="form.busy">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="4"
                 md="4">
            <v-dialog v-model="slideInfoDialog"
                      max-width="90%">
              <template v-slot:activator="{ on }">
                <v-img :src="slide.image_url"
                       :title="slide.name"
                       :alt="slide.name"
                       class="border"
                       style="cursor: pointer;"
                       contain
                       v-on="on">
                </v-img>
              </template>
              <v-card flat>
                <v-card-title class="d-flex justify-space-between">
                  <div>
                    {{ slide.name }}
                  </div>
                  <v-btn @click.prevent="closeSlideInfoDialog"
                         color="primary"
                         tile>
                    Close
                  </v-btn>
                </v-card-title>
                <v-img :src="slide.image_url"
                       :title="slide.name"
                       :alt="slide.name"
                       class="border"
                       contain>
                </v-img>
              </v-card>
            </v-dialog>

            <div class="text-caption text-center text-uppercase">
              Slide ID {{ slide.id }}
            </div>
            <div class="text-caption text-center text-uppercase">
              Slide #{{ slide.position }}
            </div>

            <div class="d-flex justify-center align-center">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :color="slide.color"
                         tile
                         dark
                         v-bind="attrs"
                         v-on="on">
                    {{ slide.status }}
                    <v-icon right>
                      fas fa-fw fa-chevron-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense
                        flat
                        tile>
                  <v-list-item v-if="!slide.is_draft && !slide.is_replaced && draftSlides.length > 0"
                               @click.prevent="showReplaceDialog">
                    <v-list-item-content>
                      <v-list-item-title>
                        Replace
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!slide.is_active && !slide.is_missing"
                               @click.prevent="activateSlide">
                    <v-list-item-content>
                      <v-list-item-title>
                        Activate
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!slide.is_inactive && !slide.is_replaced"
                               @click.prevent="deactivateSlide">
                    <v-list-item-content>
                      <v-list-item-title>
                        Deactivate
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-col>

          <v-col cols="12"
                 sm="8"
                 md="8">

            <v-text-field v-model="form.name"
                          label="Name"
                          outlined
                          dense
                          :counter="100"
                          maxlength="100"
                          required
                          :error-messages="form.errors.get('name')">
            </v-text-field>

            <v-textarea v-model="form.description"
                        label="Description"
                        placeholder="Optional"
                        rows="2"
                        outlined
                        dense
                        :counter="1000"
                        maxlength="1000"
                        :error-messages="form.errors.get('description')">
            </v-textarea>

            <v-textarea v-model="form.instructions"
                        label="Instructions"
                        placeholder="Optional"
                        rows="2"
                        outlined
                        dense
                        :counter="1000"
                        maxlength="1000"
                        :error-messages="form.errors.get('instructions')">
            </v-textarea>

            <v-switch v-model="form.is_required"
                      inset
                      :color="form.is_required ? 'error' : ''"
                      :label="form.is_required ? 'Required in new custom presentations' : 'Optional in new custom presentations'"
                      hide-details
                      class="my-0"
                      @change="changeRequired">
            </v-switch>

          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="12"
                 sm="4"
                 md="4">

          </v-col>
          <v-col cols="12"
                 sm="8"
                 md="8">
            <v-btn type="submit"
                   color="primary"
                   small
                   :disabled="form.busy">
              Update slide
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <ReplaceSlideDialog v-if="replaceSlideDialog"
                        :dialog="replaceSlideDialog"
                        :slide="slide"
                        @updated="slideReplaced"
                        @closed="closeReplaceDialog">
    </ReplaceSlideDialog>
  </v-form>
</template>
<script>
import {Form} from 'vform';
import slideDeckService from '../../../services/slideDeckService';
import ReplaceSlideDialog from './ReplaceSlideDialog.vue';

export default {
  components: {ReplaceSlideDialog},
  props: {
    slide: {
      type: Object,
      required: true,
    },
    slides: {
      type: Array,
      required: false,
      default: [],
    }
  },
  data() {
    return {
      slideInfoDialog: false,
      form: new Form({
        name: this.slide.name,
        is_required: this.slide.is_required,
        status: this.slide.status,
        description: this.slide.description,
        instructions: this.slide.instructions,
        replace_with_slide_id: null,
      }),
      replaceSlideDialog: false,
      statusCodes: slideDeckService.getStatusCodes(),
    }
  },
  watch: {
    slide(newSlide) {
      this.initForm(newSlide);
    }
  },
  computed: {
    slideID() {
      return this.slide.id;
    },
    draftSlides() {
      return this.slides.filter(s => s.is_draft);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    initForm(slide) {
      this.form.name = slide.name;
      this.form.is_required = slide.is_required;
      this.form.status = slide.status;
      this.form.description = slide.description;
      this.form.instructions = slide.instructions;
    },
    fetchData() {

    },
    changeRequired() {
      /*if (this.form.is_required) {
        this.form.status = 'Active';
      }*/
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      slideDeckService.update(this.form, this.slideID)
        .then(data => {
          if (data.updated) {
            this.$toast.success('Slide updated');
            //this.$emit('updated');
          } else {
            //this.$toast.info('No change');
          }
        })
        .catch(err => {
          this.$toast.error('There was an error updating the slide. Check your input.');
        })
    },
    async activateSlide() {
      await slideDeckService.changeSlideStatus(this.slide.id, 'Active')
      this.$emit('updated');
    },
    async deactivateSlide() {
      await slideDeckService.changeSlideStatus(this.slide.id, 'Inactive')
      this.$emit('updated');
    },
    showSlideInfoDialog() {
      this.slideInfoDialog = true;
    },
    closeSlideInfoDialog() {
      this.slideInfoDialog = false;
    },
    async showReplaceDialog() {
      this.replaceSlideDialog = true;
    },
    closeReplaceDialog() {
      this.replaceSlideDialog = false;
    },
    slideReplaced() {
      this.closeReplaceDialog();
      this.$emit('updated');
    }
  }
}
</script>
